const state = {
	manualPoItems: [],
};

const getters = {
	manualPoItemList: (state: { manualPoItems: any }) => {
		return state.manualPoItems;
	},
};

const mutations = {
	updateManualPoItems: (state: { manualPoItems: any }, payload: any) => {
		state.manualPoItems = payload;
	},
};

const actions = {
	updateManualPoItems: ({ commit }: any, payload: any) => {
		commit("updateManualPoItems", payload);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
